import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
import { SocialProofPopup } from './components/SocialProofPopup';
// Add type definition for Facebook Pixel
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Code Injection
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '832917643091578');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=832917643091578&ev=PageView&noscript=1"
      />
    `;
    document.body.appendChild(noscript);
    // Cleanup not strictly necessary for pixel but good practice if SPA routing was used
    return () => {
      // We don't remove the pixel on unmount to track properly
    };
  }, []);
  return <div className="min-h-screen bg-[#080c24]" data-id="element-0">
      <SalesPage data-id="element-1" />
      <SocialProofPopup data-id="element-2" />
    </div>;
}